import { useEffect, useState } from 'react';
import { DestinationsApi } from '../../apis/destinations.api';
import { CampaignCreativeModel } from '../../models/campaign-creative.model';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { IAskError } from '@monorepo/tools/src/lib/tools/ask/ask';
import { isAbortError } from '@monorepo/tools/src/lib/tools/ask/guards';

export const useDestinationCreatives = (destinationId?: id, advertiserId?: id) => {
	const [creatives, setCreatives] = useState<CampaignCreativeModel[]>([]);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (!destinationId) {
			setCreatives([]);
			setIsLoading(false);
			return;
		}

		let cancelled = false;
		setIsLoading(true);
		setCreatives([]);

		const params = new URLSearchParams();
		if (advertiserId != null) {
			params.set('advertiser_id', String(advertiserId));
		}

		void DestinationsApi.listCreatives(destinationId, params)
			.then(response => {
				if (cancelled) {
					return;
				}
				setCreatives(response);
				setIsLoading(false);
			})
			.catch((error: IAskError) => {
				if (cancelled || isAbortError(error)) {
					return;
				}
				setCreatives([]);
				setIsLoading(false);
			});

		return () => {
			cancelled = true; // no ask.addSignal, no abort()
		};
	}, [destinationId, advertiserId]);

	return {
		creatives,
		isLoading,
	};
};
